import { getInitialState, getPath } from "../../utils";
import primeState from "./InitialStates/AssetsIssuance";

const initialState = { ...primeState };

export default function (state = initialState, action) {
  switch (action.type) {
    case "ASSETS_ISSUANCE_SET_DRIVER_DETAILS":
      return setDriverDetails(state, action);
    case "ASSETS_ISSUANCE_SET_ISSUING_ASSETS":
      return setIssuingAssets(state, action);
    case "ASSETS_ISSUANCE_SET_PARTNER_DETAILS":
      return setPartnerDetails(state, action);
    case "ASSETS_ISSUANCE_RESET_DRIVER_DETAILS":
      return resetDriverDetails(state, action);
    case "ASSETS_ISSUANCE_RESET_PARTNER_DETAILS":
      return resetPartnerDetails(state, action);
    case "ASSETS_ISSUANCE_RESET_ISSUING_ASSETS":
      return resetIssuingAssets(state, action);
    default:
      return state;
  }
}

const setDriverDetails = (state, action) => {
  return {
    ...state,
    driverDetails: {
      pan_number: getPath(action.payload.payload, "pan_no", ""),
      phone_number: getPath(action.payload.payload, "phone_no", ""),
      driver_id: getPath(action.payload.response, "driver_id", ""),
    },
  };
};

const resetDriverDetails = (state, _) => {
  return {
    ...state,
    driverDetails: initialState.driverDetails,
  };
};

const setPartnerDetails = (state, action) => {
  return {
    ...state,
    partnerDetails: {
      onboarding_center_id: getPath(action.payload, "id", ""),
    },
  };
};

const resetPartnerDetails = (state, _) => {
  return {
    ...state,
    partnerDetails: initialState.partnerDetails,
  };
};

const setIssuingAssets = (state, action) => {
  return {
    ...state,
    issuingAssets: {
      assets_data: getPath(action.payload, "assets_data", {}),
      transaction_id: getPath(action.payload, "assets_issuance_id", undefined),
    },
  };
};

const resetIssuingAssets = (state, _) => {
  return {
    ...state,
    issuingAssets: initialState.issuingAssets,
  };
};
